export default __webpack_public_path__ + "static/media/thumbnail.12e3786c.webp";